import { HTMLAttributes, ReactNode } from 'react'
import './Card.css'

export type CardVariant = 'default' | 'elevated' | 'outlined' | 'featured'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Card visual style */
  variant?: CardVariant
  /** Optional header content */
  header?: ReactNode
  /** Optional footer content */
  footer?: ReactNode
  /** Remove default padding */
  noPadding?: boolean
  /** Children elements */
  children: ReactNode
}

/**
 * Card component for content containers
 * Used for feature cards, pricing cards, dashboard sections
 */
export default function Card({
  variant = 'default',
  header,
  footer,
  noPadding = false,
  children,
  className = '',
  ...props
}: CardProps) {
  const cardClasses = [
    'ps-card',
    `ps-card--${variant}`,
    noPadding && 'ps-card--no-padding',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={cardClasses} {...props}>
      {header && <div className="ps-card__header">{header}</div>}
      <div className="ps-card__body">{children}</div>
      {footer && <div className="ps-card__footer">{footer}</div>}
    </div>
  )
}
